import React, { Component } from 'react'
import { Selector, Nav, Header } from '../NewManageUsers/ManagePane'
import { SelectLicense} from './'
import {Row, Col} from 'reactstrap'
import getAllAccountLicenses from '../../../helpers/users/licenses/getAllAccountLicenses';
import { BeatLoader } from 'react-spinners'
import getAllDistrictAdmins from '../../../helpers/users/licenses/getAllDistrictAdmins';
import toggleLicense from '../../../helpers/users/licenses/toggleLicense';
import addOrRemoveAllToLicense from '../../../helpers/users/licenses/addOrRemoveAllToLicense';
import {tallyLicenseInUserLicenses} from "../../../helpers/users/licenses/tallyLicenses";
import checkLicenseLimit,{checkLicenseLimitForSingleItem} from "../../../helpers/users/licenses/checkLicenseLimit";

class DistrictAdminLicenses extends Component {
  state = {
    activeLicense: '',
    licenses: null,
    loadingLicenses: false,
    errorLicenses: '',
    loadingAdmins: false,
    errorAdmins: '',
    admins: null,
    togglingLicense: '',
    togglingLicenseError: '',
    addingOrRemovingAll:false
  }

  componentDidMount() {
    const district = this.props.match.params.id
    getAllAccountLicenses(district, this.setState.bind(this), 'educator')
    this.unsubscribe = getAllDistrictAdmins(district, this.setState.bind(this))
  }

  componentWillUnmount() {
    this.unsubscribe && this.unsubscribe()
  }

  componentDidUpdate(prevProps) {
    const district = this.props.match.params.id
    const prevDistrict = prevProps.match.params.id
    if (district !== prevDistrict) {
      this.setState({activeLicense: ''})
      getAllAccountLicenses(district, this.setState.bind(this), 'educator')
      this.unsubscribe()
      this.unsubscribe = getAllDistrictAdmins(district, this.setState.bind(this))
    }
  }

  handleClick = (id) => this.setState({activeLicense: this.state.activeLicense === id ? '' : id})

  toggleUserLicense = (userId, licenseId) => {
    const { admins } = this.state 
    if (checkLicenseLimitForSingleItem(licenseId, this.state.licenses,userId,admins)) {
      this.showLicenseLimitError();
    }
    else {
      this.setState({togglingLicense: userId})
      
      toggleLicense(userId, admins, licenseId)
        .then(() => this.setState({togglingLicense: ''}))
        .catch(error => this.setState({togglingLicenseError: error}))
    }
    
  }
  removeOrAddAll = (actionType,licenseId,filteredUserList)=>{
    const { admins } = this.state 
    var tlius = tallyLicenseInUserLicenses(licenseId,filteredUserList);
    var difference = tlius.totalLength - tlius.count;
              
    switch(actionType){
      case 'add_all':
      this.addAll(licenseId,filteredUserList,difference);
      break;
      case 'remove_all': 
      this.removeAll(licenseId,filteredUserList,difference,tlius);
        break;
      default:
      break;
    }
  }
  addAll(licenseId,admins,difference){
    if(difference === 0 && true)
    {
      return;
    }
    else if (checkLicenseLimit(licenseId, this.state.licenses, admins)) {
      this.showLicenseLimitError();
    }
    else {
      this.setState({addingOrRemovingAll: true})
        addOrRemoveAllToLicense(licenseId,admins,true)
        .then(() => this.setState({togglingLicense: '',addingOrRemovingAll: false}))
        .catch(error => this.setState({togglingLicenseError: error}))
    }
    
  }
  showLicenseLimitError() {
    this.setState({ licenseLimitExceedError: true });
    setTimeout(() => {
      this.setState({ licenseLimitExceedError: false });
    }, 1500);
  }
  removeAll(licenseId,admins,difference,tlius){
    if (difference === tlius.totalLength && !false)
    { 
     return;
    }
    else {
      this.setState({addingOrRemovingAll: true})
        addOrRemoveAllToLicense(licenseId,admins,false)
        .then(() => this.setState({togglingLicense: '',addingOrRemovingAll: false}))
        .catch(error => this.setState({togglingLicenseError: error}))
       
       }
    

  }
  render() {
    const { 
      licenses, 
      loadingLicenses, 
      errorLicenses, 
      activeLicense,
      errorAdmins,
      loadingAdmins,
      admins,addingOrRemovingAll,
      licenseLimitExceedError
    } = this.state
    const { districts, history, user, match, } = this.props
    const { handleClick, toggleUserLicense,removeOrAddAll } = this
    const { params } = match
    const district = params.id
    const loading = !!(loadingLicenses || loadingAdmins)
    return (
      <React.Fragment>
        {
          !loading ? <React.Fragment>
            <Row className="licenses-header">
              <Col>
              <Selector 
            districts={districts}
            schools={null}
            teachers={null}
            id={district}
            user={user}
            history={history}
            baseLink='/users/licenses/district-admins/'
            selectorLevel={'district'}
            
          />
              </Col>
            </Row>
            {
              !loadingLicenses && !loadingAdmins && <Row className="licenses-body"><Col x='12'>
               <Header>District Admin Licenses</Header></Col>
               <Col xs='12'>
               <h5>Select License</h5>
               {
                 licenses && !loadingLicenses?<SelectLicense 
                 licenses={licenses}
                 handleClick={handleClick}
                 activeLicense={activeLicense}
                 users={admins}
                 toggleUserLicense={toggleUserLicense}
                 loadingUsers={loadingAdmins}
                 errorUsers={errorAdmins}
                 userType="district admins"
                  removeOrAddAll={removeOrAddAll}
                  addingOrRemovingAll={addingOrRemovingAll}
                  licenseLimitExceedError={licenseLimitExceedError}
               />: !loadingLicenses && <p>No licenses available in this account.</p>
               }</Col></Row>
            }
          </React.Fragment>:<BeatLoader loading={loading}/>
        }
 <Nav back={'/users/licenses/district-admins'}/>
      </React.Fragment>
      
    )
  }
}

export default DistrictAdminLicenses



// WEBPACK FOOTER //
// ./src/components/Users/Licenses/DistrictAdminLicenses.js